/**
 * @generated SignedSource<<629b6919363e05a5236db3c94d979c59>>
 * @relayHash 8f0c6fd97bcccddc79e9494c12da93d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eab07a8e5f68793d6dc0f52ac25f708e9a552799064c9c17ecffa24bf4814199

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery } from './uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "eab07a8e5f68793d6dc0f52ac25f708e9a552799064c9c17ecffa24bf4814199",
    "metadata": {},
    "name": "uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
